import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GdoSharedRoutingModule } from './gdo-shared-routing.module';
import { GdoSharedComponentsComponent } from './gdo-shared-components/gdo-shared-components.component';
import { GdoCancelSubscriptionConfirmationDialogComponent } from './gdo-shared-components/gdo-cancel-subscription-confirmation-dialog/gdo-cancel-subscription-confirmation-dialog.component';
import { GdoCancelSubscriptionInformationDialogComponent } from './gdo-shared-components/gdo-cancel-subscription-information-dialog/gdo-cancel-subscription-information-dialog.component';
import { GdoCancelSubscriptionDialogComponent } from './gdo-shared-components/gdo-cancel-subscription-dialog/gdo-cancel-subscription-dialog.component';
import { MatRadioModule } from '@angular/material/radio';
import { GdoConnectedGarageFeaturesDialogComponent } from './gdo-shared-components/gdo-connected-garage-features-dialog/gdo-connected-garage-features-dialog.component';
import { GdoConnectedGarageIntroductionVideoDialogComponent } from './gdo-shared-components/gdo-connected-garage-introduction-video-dialog/gdo-connected-garage-introduction-video-dialog.component';
import { GdoTermsOfUseComponent } from './gdo-shared-components/gdo-terms-of-use/gdo-terms-of-use.component';
import { GdoStepCompletionStatusComponent } from './gdo-shared-components/gdo-step-completion-status/gdo-step-completion-status.component';
import { SafeHtmlPipe } from './pipe/safe-html.pipe';
import { GdoSelectCancelSubscriptionDialogComponent } from './gdo-shared-components/gdo-select-cancel-subscription-dialog/gdo-select-cancel-subscription-dialog.component';
import { GdoCancelSubscriptionItemComponent } from './gdo-shared-components/gdo-select-cancel-subscription-dialog/gdo-cancel-subscription-item/gdo-cancel-subscription-item.component';
import { GdoInfoPopupDialogComponent } from './gdo-shared-components/gdo-info-popup-dialog/gdo-info-popup-dialog.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { GdoStepCompletionStatusWebviewComponent } from './gdo-shared-components/gdo-step-completion-status-webview/gdo-step-completion-status-webview.component';


@NgModule({
  declarations: [
    
    //container
    GdoSharedComponentsComponent,

    /* Rest of components in container*/
    GdoTermsOfUseComponent,
    GdoStepCompletionStatusComponent,
    GdoCancelSubscriptionDialogComponent,
    GdoCancelSubscriptionInformationDialogComponent,
    GdoCancelSubscriptionConfirmationDialogComponent,
    GdoConnectedGarageFeaturesDialogComponent,
    GdoConnectedGarageIntroductionVideoDialogComponent,
    SafeHtmlPipe,
    GdoSelectCancelSubscriptionDialogComponent,
    GdoCancelSubscriptionItemComponent,
    GdoInfoPopupDialogComponent,
    GdoStepCompletionStatusWebviewComponent
  
  ],
  imports: [
    CommonModule,
    MatRadioModule,
    MatCheckboxModule,
    GdoSharedRoutingModule
  ],
  exports:[
    SafeHtmlPipe
  ]
})
export class GdoSharedModule { }
